/**
 * Inicializa o slider de notícias
 */
;(function ($) {
	"use strict"

	const initNoticiasSlider = () => {
		const $slider = $(".noticias__slider")

		if (!$slider.length) return

		$slider.slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			dots: true,
			arrows: true,
			prevArrow: $(".noticias__nav-prev"),
			nextArrow: $(".noticias__nav-next"),
			infinite: true,
			speed: 300,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
					},
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						centerMode: true,
					},
				},
			],
		})
	}

	// Inicializa quando o DOM estiver pronto
	$(document).ready(initNoticiasSlider)
})(jQuery)
